// src/Utils/socket.js
import { io } from "socket.io-client";
import { getJwtToken } from "./authStorage";

let socket = null;

const SOCKET_URL =
    process.env.REACT_APP_SERVER_URL_MEDIUM || "https://zmanapi-maindata.zmanup.com" || "http://localhost:7955";

export const connectWithUid = async (uid) => {
    if (!uid) return null;

    if (socket?.connected) {
        return socket;
    }

    if (!socket) {
        socket = io(SOCKET_URL, {
            transports: ["websocket"],
            autoConnect: false,
            withCredentials: true,
        });

        socket.on("connect", () => {
            // console.log("🟢 WEB SOCKET connected", socket.id);
        });

        socket.on("disconnect", (reason) => {
            // console.log("🔴 WEB SOCKET disconnected:", reason);
        });

        socket.on("connect_error", (error) => {
            console.warn("⚠️ WEB SOCKET error:", error?.message || error);
        });
    }

    const token = getJwtToken?.();

    socket.auth = {
        uid,
        token,
        platform: "web",
    };

    socket.connect();

    return socket;
};

export const getSocket = () => socket;

export const disconnectSocket = () => {
    if (!socket) return;

    try {
        if (socket.connected) {
            socket.disconnect();
        }
    } catch (e) {
        console.warn("disconnectSocket error:", e?.message || e);
    }
};